module.exports = __webpack_public_path__ + "img/1534808112.48044c7b.jpg";